import system from './request/api'
import answer from './request/answer'
import activity from './request/activity'
import wechat from './request/wechat'
import common from './request/common'
import user from './request/user'
import sports from './request/sports'
import steps from './request/steps'
import rank from './request/rank'
import tennis from './request/tennis'
import bainian from './request/bainian'
import unions from './request/unions'
export default {
    install(Vue){
        Vue.prototype.$api = this
    },
    system,
    answer,
    activity,
    wechat,
    common,
    user,
    sports,
    steps,
    rank,
    tennis,
    bainian,
		unions
}
